export default __webpack_public_path__ + "static/media/privacy.b9db6bad.png";